import React from 'react';

export const Page_settings = React.createContext({});
